"use strict";

(function (global) {

  var WITHOUT_FILTER_NAME = '';

  /**
  * Инициализация меню предустановленных фильтров.
  * @since 5.2.0.2000
  * @return {Core.toolBars.objectList}
  */
  global.initPreFiltersMenu = WA.TCD(function () {
    var bottomSeparator;
    var menuSelector = '#predefined_filters';
    var jFilters = $(menuSelector);
    if (!jFilters.length) return;

    var jSelectedItemText = jFilters.find('.filtration-panel__dropdown-text');

    var allFilters = jFilters.data('predefinedfilters');
    var selectedFilterName = jFilters.data('predefinedselectedfilter');

    // Инициализирует фильтр.
    $.when(WA.ObjectListInit).done(function () {
      WA.CR.objectList.setPredefinedFilter(selectedFilterName);
    });

    // Предопределенные фильтры без скрытых.
    var predefinedFilters = _(allFilters).filter(function (item) {
      return !item.IsHidden;
    });
    // Фильтры по статусам. Считаем что все скрытые это статусы.
    var statuses = _(allFilters).filter(function (item) {
      return item.IsHidden;
    });


    var menuItems = _(predefinedFilters).map(function (item) {
      return {
        name: item.Name,
        label: item.Text,
        tooltip: L(item.Tooltip),
        icon: item.Icon,
        bottomSeparator: bottomSeparator,
        selected: (item.Name === selectedFilterName)
      };
    });
    // Разделитель для последнего элемента предопределенных фильтров.
    menuItems[menuItems.length - 1].bottomSeparator = true;
    // Без фильтра.
    menuItems.push({
      "name": WITHOUT_FILTER_NAME,
      "label": L("DEFAULT_EMPTY_FILTER"),
      selected: (!selectedFilterName || selectedFilterName === WITHOUT_FILTER_NAME)
    });


    var statusesMenuItems = _(statuses).map(function (item) {
      return {
        name: item.Name,
        text: L(item.Text),
        tooltip: L(item.Tooltip),
        label: item.Text,
        image: item.Icon,
        selected: (item.Name === selectedFilterName)
      };
    });

    var baseMenu = new WA.components.menus.BaseContextMenu(menuSelector, menuItems, {
      width: 220,
      shiftY: -30 //поднимаем выше оба меню.
    });
    baseMenu.render();

    if (statusesMenuItems.length > 0) {
      baseMenu._menu.onShow = function () {
        // Надо каждый раз рендерить, т.к. основное контекстное меню всё чистит.
        var statusesMenu = new WebAccess.components.menus.OnlyIconsContextMenu(menuSelector, statusesMenuItems);
        statusesMenu.render();

        statusesMenu.jMenu.css({
          'width': '210px',
          'margin-bottom': '22px' // отсутуп между меню.
        });
        statusesMenu.showIn($('#mainContextMenuContainer'), true);
        statusesMenu.bind("itemSelect", function (selectedItem) {
          onSelectFilter(selectedItem);
          ContextMenu.hide();
        });
      };
    }

    baseMenu.bind("itemSelect", onSelectFilter);

    function onSelectFilter(selectedItem) {
      jFilters.data('predefinedselectedfilter', selectedItem.name);

      // Устанавливаем новый выбранный.
      _(statusesMenuItems).each(function (item) {
        item.selected = (item.name === selectedItem.name);
      });
      _(menuItems).each(function (menuItem) {
        baseMenu.setSelectedItem(menuItem.name, menuItem.name == selectedItem.name);
      });

      var iconSymbol = '#filter' + (selectedItem.name === WITHOUT_FILTER_NAME ? 'Off' : 'On') + '-16';
      jFilters.find('use').attr('xlink:href', iconSymbol);
      jSelectedItemText.text(L(selectedItem.label));

      global.setPredefinedFilter(selectedItem.name);

      if (Core.isStatisticEnabled) {
        ///Запись в статистику
        WA.CR.statistics.write({
          page: WA.getLocation(),
          action: "PredefinedFiltering",
          area: 'FilterPanel',
          target: jFilters.get(0)
        });
      }
    }

    return global;
  });

  global.setPredefinedFilter = function (value) {
    WA.CR.objectList.setPredefinedFilter(value).reload();
  };

  /**
  * Инициализация меню сортировки.
  * @since 5.2.0.2000
  * @return {Core.toolBars.objectList}
  */
  global.initSortMenu = WA.TCD(function (id, data) {
    var ASC = 1;
    var DESC = -1;
    var OFF = 0;

    var contextMenu;
    var jSortText = $("#" + id);
    var jSortIcon = jSortText.prev();
    var currentItem = null;

    // Если нет данных для построения контектного меню скрывает сортировку.
    if ($.isEmptyObject(data)) {
      jSortText.parent().hide();
      return true;
    }

    var menuItems = [];
    $.each(data, function () {
      var itemData = this;
      var sortIcon = 'sort-16';

      menuItems.push({
        name: itemData.name,
        label: itemData.caption,
        icon: (itemData.sort === OFF ? '' : sortIcon),
        iconCSSClass: (itemData.sort === OFF ? '' : getIcon(itemData.sort === ASC)),
        selected: (itemData.sort !== OFF),
        sort: itemData.sort,
        defaultDirection: itemData.defaultDirection,
        hoverIcon: sortIcon,
        iconHoverCSSClass: getHoverIconCssClass(itemData)
      });

      if (itemData.sort !== OFF) currentItem = menuItems[menuItems.length - 1];
    });

    // Инициализирует сортировку.
    $.when(WA.ObjectListInit).done(function () {
      setSortByMenuItem(currentItem);
    });

    function sortDirectionIsAsc(item) {
      if (item.sort === OFF) {
        return item.defaultDirection === ASC;
      } else {
        return item.sort === ASC;
      }
    }
    function getHoverIconCssClass(item) {
      if (item.sort === OFF) {
        return getIcon(item.defaultDirection === ASC);
      } else {
        return getIcon(item.sort !== ASC);
      }
    }
    function getIcon(isAsc) {
      return (isAsc ? '' : 'reverse');
    }

    contextMenu = new WA.components.menus.BaseContextMenu("#" + id, menuItems);
    contextMenu.render();
    contextMenu.bind("itemSelect", function (item) {
      sortItemOnClick(item);
    });
    jSortIcon.click(function () {
      // При клике на иконку меняем сортировку на обратную.
      sortItemOnClick(currentItem);
    });

    function sortItemOnClick(clickedItem) {
      if (Core.isStatisticEnabled) {
        ///Запись в статистику
        WA.CR.statistics.write({
          page: WA.getLocation(),
          action: "Sorting",
          area: 'FilterPanel',
          target: $('#list_sort')
        });
      };

      _(menuItems).each(function (menuItem) {
        if ((currentItem) && (menuItem.name == currentItem.name)) {
          // Меняем направление текущей сортировки.
          menuItem.sort = (menuItem.sort === ASC ? DESC : ASC);
          currentItem = menuItem;
        } else
          if ((clickedItem) && (menuItem.name == clickedItem.name)) {
            // Если не текущий, но мы его выбрали устанавливаем направление по умолничаю.
            menuItem.sort = menuItem.defaultDirection;
            currentItem = menuItem;
          } else {
            // Сбрасываем сортировку для всех остальных.
            menuItem.sort = OFF;
          }
        // Сбрасываем стили и иконки.
        contextMenu.setSelectedItem(menuItem.name, false);
        menuItem.icon = '';
        menuItem.image = '';
        menuItem.iconCSSClass = '';
        menuItem.iconHoverCSSClass = getHoverIconCssClass(menuItem);
      });
      if (!currentItem) return;

      contextMenu.setSelectedItem(currentItem.name, true, 'sort-16', getIcon(currentItem.sort === ASC));

      jSortText.text(currentItem.label);

      if (currentItem.sort === ASC) jSortIcon.attr("class", "filtration-panel__dropdown-icon");
      else jSortIcon.attr("class", "filtration-panel__dropdown-icon filtration-panel__dropdown-icon_reverse");

      setSortByMenuItem(currentItem);
      WA.CR.objectList.reload();
    }

    function setSortByMenuItem(currentItem) {
      if (!currentItem) return;

      var column = currentItem.name;
      var isAsc = (currentItem.sort === ASC);
      WA.CR.objectList.setSort(column, isAsc)
    }
  });
})(window.Core.toolBars.objectList);
